// --------------------
// BRACKET HELPERS
// --------------------

export function getRoundLabel(roundIndex, totalRounds, totalTeams) {
  const labels = {
    2: ['Final'],
    4: ['Semifinals', 'Final'],
    8: ['Quarterfinals', 'Semifinals', 'Final'],
    16: ['Round of 16', 'Quarterfinals', 'Semifinals', 'Final'],
    32: ['Round of 32', 'Round of 16', 'Quarterfinals', 'Semifinals', 'Final'],
    64: ['Round of 64', 'Round of 32', 'Round of 16', 'Quarterfinals', 'Semifinals', 'Final'],
  };

  if (labels[totalTeams]) {
    const offset = labels[totalTeams].length - totalRounds;
    return labels[totalTeams][roundIndex + offset] || `Round ${roundIndex + 1}`;
  }

  if (totalRounds - roundIndex === 1) return 'Final';
  if (totalRounds - roundIndex === 2) return 'Semifinals';
  if (totalRounds - roundIndex === 3) return 'Quarterfinals';

  return `Round ${roundIndex + 1}`;
}


export function getBoxColor(colorScheme, matchIndex) {
  if (colorScheme === "yellow-black") {
    return matchIndex % 2 === 0
      ? { backgroundColor: "#948c67", color: "#ffffff" }
      : { backgroundColor: "#b0acac", color: "#ffffff" };
  }

  return {}; // default
}

export function isTeamAlreadyPlaced(team_id, bracketData) {
  for (const round of bracketData.rounds) {
    for (const match of round) {
      if (!match) continue;

      if (match.teamA?.slt_id == team_id) return true;
      if (match.teamB?.slt_id == team_id) return true;
    }
  }
  return false;
}

export function gameHasScore(games, matchId) {
  const g = games.find((x) => x.match_id === matchId);
  if (!g) return false;

  const home = g.score_home ?? g.score_team1;
  const away = g.score_away ?? g.score_team2;

  return (
    home != null &&
    away != null &&
    home !== "" &&
    away !== "" &&
    Number(home) !== 0 &&
    Number(away) !== 0
  );
}
